import { Component, inject, input, InputSignal } from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { Coaching, GpsOnly, VideoSection, Workout } from '@kinomap-dev/ng-ui-lib/core';
import { ContentGlobalStatsItem } from '../content-global-stats-item/content-global-stats-item';
import { Tooltip } from '../../directives/tooltip.directive';
import { ColorService } from '../../services/color.service';
import { TranslateModule } from '@ngx-translate/core';

export type ContentGlobalStatsBlockPropsType = { label: string; icon: string; value: number }[];

@Component({
  selector: 'app-content-global-stats-block',
  imports: [IconComponent, ContentGlobalStatsItem, Tooltip, TranslateModule],
  templateUrl: './content-global-stats-block.html',
  styleUrl: './content-global-stats-block.scss',
})
export class ContentGlobalStatsBlock {
  readonly colorService: ColorService = inject(ColorService);

  readonly content: InputSignal<any | undefined> = input();
}
